import React from 'react';
import logo from '../images/logosuper.png'
import { Link, useLocation } from "react-router-dom";

const Header = () => {

    const usuario = localStorage.getItem('usuario')

    const CerrarSesion = e => {
        e.preventDefault();

        localStorage.clear();
        window.location.replace('/');
    }
    
    let location = useLocation();

    return ( 
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <img src={logo} alt="Logo SuperIntendencia" className="img-fluid logo-super navbar-brand"/>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mx-auto">
                    <li className="nav-item active m-login">
                        <Link className={location.pathname === '/' ? "nav-item nav-link nav-menu active" : "nav-item nav-link "} id="inicio-menu" to="/">Inicio </Link>
                    </li>
                    <li className="nav-item m-login">
                        <a className="nav-item nav-link menu-api" href="https://docu-prestadores-api.readthedocs.io/en/latest/">Documentación </a>
                    </li>
                    {usuario !== "" && usuario !== null ? 
                        <li className="nav-item m-login">
                            <Link className={location.pathname === '/prestadores' ? "nav-item nav-link nav-menu active" : "nav-item nav-link "} id="prestadores-menu" to="/prestadores">Prestadores </Link>
                        </li>
                    :null}
                   

                    {usuario !== "" && usuario !== null ? 
                    <li className="nav-item">
                        <div className="dropdown d-block d-lg-none">
                            <a className="btn btn-primaryy mx-2 dropdown-toggle" href="/#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {usuario}
                            </a>

                            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <Link className="dropdown-item" to="/modificar">Modificar Contraseña</Link>
                                <button className="dropdown-item" onClick={CerrarSesion} to="/modificar">Cerrar Sesión</button>
                            </div>

                        </div> 
                    </li>
                    :
                    
                    <li className="nav-item d-block d-lg-none">
                        <Link to ='/login' className="d-block d-lg-none nav-item m-login" >
                                Iniciar Sesión
                        </Link>
                    </li>
                    }

                </ul>
            </div>

            {/* DESKTOP */}
            {usuario !== "" && usuario !== null ? 
            <>
                <div className="dropdown d-none d-lg-block">
                    <a className="btn btn-primaryy mx-2 dropdown-toggle" href="/#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {usuario}
                    </a>

                    <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <Link className="dropdown-item" to="/modificar">Modificar Contraseña</Link>
                    </div>
                </div>     

                <button className="btn btn-secondary mr-3 btn-send d-none d-lg-block" type="button" data-toggle="collapse" data-target="#reporte_casos_card" onClick={CerrarSesion} aria-expanded="true" aria-controls="reporte_casos_card">
                Cerrar Sesión
                </button>
            </>
            : 
            <>
                <Link to ='/login' className="d-none d-lg-block">
                <button className="btn btn-secondary mr-3 btn-send" type="button" data-toggle="collapse" data-target="#reporte_casos_card" aria-expanded="true" aria-controls="reporte_casos_card">
                    Iniciar Sesión
                </button>
                </Link>

                {/* <Link to ='/registrar'>
                    <button className="btn btn-primary" type="button" data-toggle="collapse" data-target="#reporte_casos_card" aria-expanded="true" aria-controls="reporte_casos_card">
                        Registrarse
                    </button>
                </Link> */}
            </>
            }
        </nav>


     );
}
 
export default Header;